module.exports = __webpack_public_path__ + "img/logo-OJK.a7e56320.png";